/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasterScheduleLegendsResponse } from '../../models/master-schedule-legends-response';

export interface GetMasterScheduleLegends$Params {
}

export function getMasterScheduleLegends(http: HttpClient, rootUrl: string, params?: GetMasterScheduleLegends$Params, context?: HttpContext): Observable<StrictHttpResponse<MasterScheduleLegendsResponse>> {
  const rb = new RequestBuilder(rootUrl, getMasterScheduleLegends.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MasterScheduleLegendsResponse>;
    })
  );
}

getMasterScheduleLegends.PATH = '/api/scheduler/master-schedule/legends';
